import script from "./BindPayPalRule.vue?vue&type=script&lang=ts&setup=true"
export * from "./BindPayPalRule.vue?vue&type=script&lang=ts&setup=true"

import "./BindPayPalRule.vue?vue&type=style&index=0&id=6e508ce0&lang=css"
import "./BindPayPalRule.vue?vue&type=style&index=1&id=6e508ce0&scoped=true&lang=css"

import exportComponent from "/Users/carl/project/meta/landings/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e508ce0"]])

export default __exports__